<template>
  <div id="homepage">

    <div class="parallax py-4">
      <div class="container align-middle py-4">
        <div class="row d-flex justify-content-center ">
          <div class="col-lg-8 col-md-10 col-sm-12 py-4">
            <img class="img-fluid" src="../assets/kibigo.png"/>

          </div>
        </div>
      </div>
    
    </div>

        <section class="content-section bg-light" id="about">
          <div class="container text-center">
            <div class="row">
              <div class="col-lg-10 mx-auto">
                <h2>{{$t("h_main_title")}}</h2>
                <p class="lead mb-5">{{$t("h_main_des")}} <a  href="https://kinoa.tech"> Kinoa</a>{{$t("h_main_des1")}} </p>
              </div>
            </div>
          </div>
        </section>

        

        <!-- Services -->
        <section class="content-section text-white text-center" id="services" style="background-color: #f0932b;">
          <div class="container">

            <div class="content-section-heading">
              <h3 class="text-primary mb-0">{{$t("h_exp_pretitle")}}</h3>
              <h2 class="mb-5">{{$t("h_exp_title")}}</h2>
              
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                <span class="service-icon rounded-circle mx-auto mb-3">
                  <i class="far fa-lightbulb"></i>
                </span>
                <h4>
                  <strong>{{$t("h_exp_wow_title")}}</strong>
                </h4>
                <p class="text-faded mb-0">{{$t("h_exp_wow_des")}} </p>
              </div>
              <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                <span class="service-icon rounded-circle mx-auto mb-3">
                  <i class="fas fa-coins"></i>
                </span>
                <h4>
                  <strong>{{$t("h_exp_bone_title")}}</strong>
                </h4>
                <p class="text-faded mb-0">{{$t("h_exp_bone_des")}}</p>
              </div>
              <div class="col-lg-3 col-md-6 mb-5 mb-md-0">
                <span class="service-icon rounded-circle mx-auto mb-3">
                  <i class="fas fa-cogs"></i>
                </span>
                <h4>
                  <strong>{{$t("h_exp_shape_title")}}</strong>
                </h4>
                <p class="text-faded mb-0">{{$t("h_exp_shape_des")}}</p>
              </div>
              <div class="col-lg-3 col-md-6">
                <span class="service-icon rounded-circle mx-auto mb-3">
                  <i class="fas fa-gift"></i>
                </span>
                <h4>
                  <strong>{{$t("h_exp_pack_title")}}</strong>
                </h4>
                <p class="text-faded mb-0">{{$t("h_exp_pack_des")}}</p>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12 mb-5 mb-lg-0">
                <h5>
                  <strong>{{$t("h_exp_BC")}}</strong>
                </h5>
              </div>
            </div>
          </div>
        </section>


        <!-- Services -->
        <section class="content-section text-white text-center bg-primary" id="services" >
          <div class="container">
            <div class="content-section-heading">
              <h3 class="text-secondary mb-0">{{$t("h_fior_pretitle")}}</h3>
              <h2 class="mb-5">{{$t("h_fior_title")}}</h2>
            </div>
            <div class="row justify-content-center">
              <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                <img src="../assets/fiorinov2.png" class="fiorino">
                <h4>
                  <strong>{{$t("h_fior_coin_title")}}</strong>
                </h4>
                <p class="text-faded mb-0">{{$t("h_fior_coin_des")}}</p>
              </div>
              <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                  <img src="../assets/backv2.png" class="fiorino">
                <h4>
                  <strong>{{$t("h_fior_philosophy_title")}}</strong>
                </h4>
                <p class="text-faded mb-0">{{$t("h_fior_philosophy_des")}}</p>
              </div>
            </div>
          </div>
        </section>
        <!-- Portfolio -->
        <section class="content-section" id="portfolio">
          <div class="container">
            <div class="content-section-heading text-center">
              <h3 class="text-secondary mb-0">{{$t("h_MiK_pretitle")}}</h3>
              <h2 class="mb-5">{{$t("h_MiK_title")}}</h2>
            </div>
            <div class="row no-gutters">
              <div v-for="project in featured" class="col-lg-6 p-2">
                <router-link :to="{name: 'ProjectDetail', params: { id: project.id}}">
                  <a class="portfolio-item" href="#">
                    <span class="caption">
                      <span class="caption-content">
                        <h1>{{project.title}}</h1>
                        <p v-if="getCurrentLang() == 'en'" class="mb-0">{{project.tldr_en}}</p>
                        <p v-else class="mb-0">{{project.tldr}}</p>
                      </span>
                    </span>
                    <img class="img-fluid" :src="project.image" alt="">
                  </a>
                </router-link>
              </div>
              <div v-if="featured.length > 3" class="col-lg-6">
                <router-link :to="{name: 'Projects'}">
                  <a class="portfolio-item" href="#">
                    <span class="caption">
                      <span class="caption-content">
                        <h1>...</h1>
                        <p class="mb-0">Scopri altri progetti...</p>
                      </span>
                    </span>
                    <img class="img-fluid" :src="third.image" alt="">
                  </a>
                </router-link>
              </div>
            </div>
          </div>
        </section>



        <!-- Call to Action -->
        <section class="content-section bg-primary text-white">

          <div class="container text-center pb-4">
            <h2 class="mb-4">{{$t("h_btn_join_title")}}</h2>
            <router-link :to="{ name: 'ContactUs'}">
            <a class="btn btn-xl btn-light mr-4">{{$t("h_btn_join_btn")}}</a>
            </router-link>
          </div>

          <div class="container text-center pt-4">
            <h4 class="mb-4">{{$t("h_btn_more_title")}}</h4>
            <router-link :to="{ name: 'Mission'}">
            <a class="btn btn-light mr-4">{{$t("h_btn_more_btn")}}</a>
            </router-link>
          </div>
          
        </section>

        <h3 class="text-center mt-5 texto">{{$t("h_mece")}}</h3>
            <div id="partecipanti" class="container d-flex justify-content-center align-items-center flex-wrap pb-5">
          <img src="../assets/microsoft.png" class="mx-4" style="filter: brightness(0); width: 160px; height: 45px;">
          <img src="../assets/ibm.png" class="mx-4" style="filter: brightness(0); width: 110px; height: 40px;">
          
        </div>
     
        <!-- Footer -->
        <!-- <footer class="footer text-center">
          <div class="container">
            <ul class="list-inline mb-5">
              <li class="list-inline-item">
                <a class="social-link rounded-circle text-white mr-3" href="instagram.com/kibigo.kinoa/">
                  <i class="icon-social-instagram"></i>
                </a>
              </li>
            </ul>
            <p class="text-white small mb-0">Copyright &copy; Kinoa 2018</p>
          </div>
        </div>
      </div>
    </section>


    <section class="content-section text-white text-center bg-primary" id="services">
      <div class="container">
        <div class="content-section-heading">
          <h3 class="text-secondary mb-0">LA MONETA DELLA CREATIVITÀ</h3>
          <h2 class="mb-5">Il Fiorino</h2>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <img src="../assets/fiorino.png" class="fiorino">
            <h4>
              <strong>Moneta virtuale</strong>
            </h4>
            <p class="text-faded mb-0">Il Fiorino, la moneta della creatività, è la nostra moneta virtuale. Forniamo 500 Fiorini ad ogni team, da investire per realizzare la propria idea.</p>
          </div>
          <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <img src="../assets/fiorinoback.png" class="fiorino">
            <h4>
              <strong>Filosofia</strong>
            </h4>
            <p class="text-faded mb-0">Il Fiorino è stata la moneta della creatività di artisti, scienziati e innovatori Rinasciementali. Noi abbiamo coniato la nostra mo...</p>
          </div>
        </div>
      </div>
    </section>

    <section class="content-section" id="portfolio">
      <div class="container">
        <div class="content-section-heading text-center">
          <h3 class="text-secondary mb-0">PROGETTI DI CUI ANDIAMO FIERI</h3>
          <h2 class="mb-5">Made in KibiGo</h2>
        </div>
        <div class="row no-gutters">
          <div v-for="project in featured" class="col-lg-6">
            <router-link :to="{name: 'ProjectDetail', params: { id: project.id}}">
              <a class="portfolio-item" href="#">
                <span class="caption">
                  <span class="caption-content">
                    <h1>{{project.title}}</h1>
                    <p class="mb-0">{{project.tldr}}</p>
                  </span>
                </span>
                <img class="img-fluid" :src="project.image" alt="">
              </a>
            </router-link>
          </div>
          <div v-if="featured.length > 3" class="col-lg-6">
            <router-link :to="{name: 'Projects'}">
              <a class="portfolio-item" href="#">
                <span class="caption">
                  <span class="caption-content">
                    <h1>...</h1>
                    <p class="mb-0">Scopri altri progetti...</p>
                  </span>
                </span>
                <img class="img-fluid" :src="third.image" alt="">
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="content-section bg-primary text-white">
      <div class="container text-center">
        <h2 class="mb-4">Il bottone a cui è impossibile resistere...</h2>
        <router-link :to="{ name: 'ContactUs'}">
          <a style="color: #1d809f" class="btn btn-xl btn-light mr-4">PARTECIPA</a>
        </router-link>
      </div>
    </section>

    <h3 class="text-center mt-5 texto">I nostri mecenati</h3>
    <div id="partecipanti" class="container d-flex justify-content-center align-items-center flex-wrap pb-5">
      <img src="../assets/microsoft.png" style="filter: brightness(0); width: 160px; height: 45px;">
      <img src="../assets/ibm.png" style="filter: brightness(0); width: 110px; height: 40px;">
      <img src="../assets/unifi.jpg" style="width: 200px; height: 90px;">
    </div>
      -->

  </div>

</template>




<script>
import { database, storage } from "@/firebase";
export default {
  name: "Homepage",
  data() {
    return {
      featured: [],
      third: {}
    };
  },
  methods: {
    getCurrentLang: function() {
      var current_locale = "en"
      if (navigator.language.includes("it")){
        current_locale = "it"
      }      
      return current_locale
    }
  },
  created() {
    database
      .collection("Projects")
      .where("isFeatured", "==", true)
      .get()
      .then(querySnapshot => {
        let index = 0;
        querySnapshot.forEach(element => {
          storage
            .child("Projects/" + element.id + "/profilo")
            .getDownloadURL()
            .then(url => {
              if (index <= 2) {
                index++;
                this.featured.push({
                  ...element.data(),
                  id: element.id,
                  image: url
                });
              } else
                this.third = {
                  ...element.data(),
                  id: element.id,
                  image: url || "http://placehold.it/1920x1080"
                };
            });
        });
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.business-header {
  height: 50vh;
  min-height: 350px;
  background: #303030;
  background: urlcenter scroll;
  background-size: cover;
}

#partecipanti img {
  padding: 5px;
  margin: 5px;
  width: 150px;
  height: 100%;
}
.fiorino {
  max-width: 110px;
  height: auto;

  padding-bottom: 15px;
}

.textall {
  color: #303030;
}

.texto {
  color: #f0932b;
}

.sottotexto {
  color: #f0932b;
  margin-top: 18%;
  font-size: 23px;
}

.subtexto {
  color: #777777;
  margin-top: -15px;
}

.titler {
  color: #f0932b;
  font-weight: bold;
}

.buttora {
  color: rgb(71, 71, 71);
  background-color: #f0932b;
}

.logos {
  height: 150px;
  font-weight: 150px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.logo2 {
  height: 363px;
  font-weight: 800px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.parallax {
  background-color: #2c3e50;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

div.button {
  height: 60px;
  width: 200px;
  border-radius: 10px;
  font-family: Helvetica;
  font-size: 0.8em;
  background: #f0932b;
  text-align: center;
  box-shadow: 0 6px #ce7716;
}



a:active div.button {
  position: relative;
  top: 4px;
  box-shadow: 0 2px #ce7716;
}

.loginbutton {
  background-color: #d6780d;
  border: none;
  color: rgb(255, 255, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue